import { ref, computed } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { useFilterStore} from './filter-store'
import { useSearchStore} from './search-store'
import { searchEndpoint, productEndpoint } from '../services/nopAPI';
// import { useProductStore } from "./product-store";

export const useDropdownSearchStore = defineStore('dropdownSearch', () => {

  const dropdownProductResults = ref([]);
  const dropdownPricingResults = ref([]);
  // const dropdownProductImageResults = ref([]);
  const dropdownProductsPerPage = ref(10);
  const dropdownprodStartPage = ref(1);
  const searchContentLoader = ref(false);

//   const parserOptions = ref('&q.parser=structured&q.options=%7B%22defaultOperator%22%3A%22and%22%2C%22fields%22%3A%5B%22sku%5E100%22%2C%20%22name%5E50%22%2C%20%22shortdescription%5E10%22%2C%20%22fulldescription%5E4%22%5D%7D');

  const { searchedString } = storeToRefs(useSearchStore());
  // const { getProductsDetailsById } = useProductStore();
//   const { appliedProductFilters } = storeToRefs(useFilterStore());
  const { buildQField } = useFilterStore()

  const dropdownProductMatchCount = computed(() => {
    if (dropdownProductResults.value.hits && dropdownProductResults.value.hits.found) {
      return dropdownProductResults.value.hits.found;
    }
    return 0;
  });

  

  const productIdList = computed(() => {
    if (dropdownProductMatchCount.value) {
      return dropdownProductResults.value.hits.hit.map((hit) => hit.fields.documenttype_id);
    }
    return [];
  });


  const dropdownProductSearchResults = computed(() => {
    if (dropdownProductResults.value.hits && dropdownProductResults.value.hits.found) {
      return dropdownProductResults.value.hits.hit.map((item) => {
        const id = item.fields.documenttype_id;
        const defaultPricing = {
          pricing: {
            StockQuantity: null,
            ProductsPrice: null,
          },
        };
        
        // const productImg=dropdownProductImageResults.value[id] || null;
        const productImg=dropdownPricingResults.value[id]?.ImageUrl || null;
        const pricing = { pricing: dropdownPricingResults.value[id] } || defaultPricing;
        const match = { id, ...item.fields, ...pricing,productImg };
        return match;
      });
    }
    return [];
  });

  async function dropdownSearchProducts(suggestionProductName=null) {
    if (searchedString.value) {
        let query=`q=(or${buildQField(searchedString.value)})&q.parser=structured`;
        if(suggestionProductName){
          suggestionProductName = suggestionProductName.replace(/&/, '%26');
          query += `&fq=(and(term field%3Dl2_ '${suggestionProductName}'))`
        }

        const productRes = await searchEndpoint.search(query)
        dropdownProductResults.value = productRes
        getProductPriceAndStock();
    }
  }

  /*
    async function getProductsBySearchString(searchString){
        const size = dropdownProductsPerPage.value === 10 ? '' : `&size=${dropdownProductsPerPage.value}`;
        const start = dropdownprodStartPage.value === 1 ? '' : `&start=${dropdownprodStartPage.value}`;
        let query = `q=(or${buildQField(searchString)})${parserOptions.value}${size}${start}&fq=${appliedProductFilters.value}`;
    
        if(!isDropDownSearch.value){
            getProductPriceAndStock();
        }
    }
  */

  async function getProductPriceAndStock() {
    if (dropdownProductMatchCount.value) {
      /*
      productIdList.value.map(async (id) => {
        if (dropdownPricingResults.value[id] && dropdownPricingResults.value[id].loaded) return
          await productEndpoint.getProductPriceAndStock([id])
          .then((priceAndStock) => {
            const stuff = {
              loaded: true,
              id: priceAndStock.ProductsPricing[0].Id,
              ProductsPrice: priceAndStock.ProductsPricing[0].ProductsPrice,
              StockQuantity: priceAndStock.ProductsPricing[0].StockQuantity,
              ShowStock: priceAndStock.ProductsPricing[0].ShowStock,
              StockStatus: priceAndStock.ProductsPricing[0].StockStatus,
            };
            dropdownPricingResults.value[id] = stuff
          })
          .catch(() => {
            const stuff = {
              loaded: false,
              id,
              ProductsPrice: 'Call for price',
              StockQuantity: 'Call for stock',
            };
            dropdownPricingResults.value[id] = stuff;
          })

          await getProductsDetailsById(id) 
          .then(productRes=>{
            // console.log({productRes});
            // if(productRes.IsSuccess){
              dropdownProductImageResults.value[id] = productRes?.DefaultPictureModel?.ImageUrl;
            // }
          })
      })
      */
    //  console.log('prodcut exists',dropdownPricingResults.value,dropdownPricingResults.value.every(item => item.loaded === true));
    //   if(dropdownPricingResults.value.length > 0) return;

     await productEndpoint.getProductPriceAndStock(productIdList.value)
     .then((priceAndStock) => {
        productIdList.value.map(async (id,index) => {
          const stuff = {
          loaded: true,
          id: priceAndStock.ProductsPricing[index].Id,
          ProductsPrice: priceAndStock.ProductsPricing[index].ProductsPrice,
          StockQuantity: priceAndStock.ProductsPricing[index].StockQuantity,
          ShowStock: priceAndStock.ProductsPricing[index].ShowStock,
          StockStatus: priceAndStock.ProductsPricing[index].StockStatus,
          ImageUrl: priceAndStock.ProductsPricing[index].ImageUrl
        };
        dropdownPricingResults.value[id] = stuff
        })
     })
     .catch(() => {
        productIdList.value.map(async (id) => {
          const stuff = {
            loaded: false,
            id,
            ProductsPrice: 'Call for price',
            StockQuantity: 'Call for stock',
          };
          dropdownPricingResults.value[id] = stuff;
        })
     })

    //  await getProductsDetailsById(productIdList.value) 
    //     .then(productRes=>{
    //         productIdList.value.map(async (id) => {
    //           dropdownProductImageResults.value[id] = productRes?.DefaultPictureModel?.ImageUrl;
    //         })
    //     })
    }
  }

  function setSearchContentLoader(){
    searchContentLoader.value=true;
  }
  function unsetSearchContentLoader(){
    searchContentLoader.value=false;
  }

  function debounce(fn, delay) {
    let timeoutId = null;
    return async function (...args) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(async () => {
        timeoutId = null;
        await fn(...args);
      }, delay);
    };
  }

  return {
    searchContentLoader,
    setSearchContentLoader,
    unsetSearchContentLoader,
    dropdownProductSearchResults,
    getProductPriceAndStock,
    dropdownSearchProducts,
    dropdownProductMatchCount,
    dropdownProductsPerPage,
    dropdownprodStartPage,
    debounce,
  };
});
